import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CloudFunctions } from '@telespot/sdk';

@Component({
    selector: 'ts-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    standalone: false
})
export class PasswordResetComponent {
  passwordResetFormErrors: string;
  passwordResetSent: boolean;
  passwordResetForm = new UntypedFormGroup({
    email: new UntypedFormControl(this.route.snapshot.queryParamMap.get('email') || '', [
      Validators.required,
      Validators.email,
    ]),
  });

  constructor(private route: ActivatedRoute) {}

  public submit() {
    const email = (this.passwordResetForm.value['email'] as string)?.toLowerCase();

    CloudFunctions.SendResetPasswordEmail(email);

    this.passwordResetSent = true;
  }
}
